module.exports = __webpack_public_path__ + "img/RuiAn_icon.4858659e.png";